import { createApp, type App } from 'vue'
import CustomNotify, { type NotifyProps } from '@/components/CustomNotify.vue'

interface ToastifyOptions extends Partial<NotifyProps> {
  message: string
}

let instance: App | null = null
let container: HTMLDivElement | null = null

export const toastify = (options: ToastifyOptions | string) => {
  const config: ToastifyOptions =
    typeof options === 'string' ? { message: options, type: 'success' } : options

  // 如果已有实例，先清理
  if (instance && container) {
    instance.unmount()
    document.body.removeChild(container)
  }

  // 创建新容器
  container = document.createElement('div')
  document.body.appendChild(container)

  // 创建组件实例
  instance = createApp(CustomNotify, {
    type: config.type || 'success',
    message: config.message,
    duration: config.duration || 3000,
  })

  const vm = instance.mount(container)

  // 调用组件的 open 方法
  if (vm && typeof (vm as any).open === 'function') {
    ;(vm as any).open()
  }

  return {
    close: () => {
      if (vm && typeof (vm as any).close === 'function') {
        ;(vm as any).close()
      }
      setTimeout(() => {
        if (instance && container) {
          instance.unmount()
          document.body.removeChild(container)
          instance = null
          container = null
        }
      }, 300)
    },
  }
}

// 便捷方法
toastify.danger = (message: string, duration?: number) => {
  return toastify({ type: 'danger', message, duration })
}

toastify.success = (message: string, duration?: number) => {
  return toastify({ type: 'success', message, duration })
}

toastify.warning = (message: string, duration?: number) => {
  return toastify({ type: 'warning', message, duration })
}

toastify.info = (message: string, duration?: number) => {
  return toastify({ type: 'info', message, duration })
}

toastify.error = toastify.danger // 别名
